// What a paste into the keyword field of a tag box becomes (boss's ticket T206). A keyword line has no line breaks of
// its own ("tag1, tag2, … tagX", it only wraps at the field's width), so the lines of a pasted list become keywords.

/**
 * Joins pasted lines into one keyword line: in each line a run of whitespace (tabs and no-break spaces too) becomes
 * one space and every comma is written as ", " (the boss's wishes 2026-10-20), the line trimmed; empty lines dropped,
 * joined by ", " — by a space only where the line already ends with a comma.
 */
export function keywordLine(text) {
    return text.split('\n')
        .map((line) => line.replace(/\s+/g, ' ').replace(/ ?, ?/g, ', ').trim())
        .filter(Boolean)
        .reduce((joined, line) => (joined === '' ? line : joined + (joined.endsWith(',') ? ' ' : ', ') + line), '');
}
